import React from 'react';
import PropTypes from 'prop-types';

const PlayerImage = ({ answer} ) => {
  return (
    <div className='o-player-cell o-player-cell__image'>
      { answer ?
        <img alt='Uploaded Answer' src={answer.imageUrl}/> :
        <span>No Image</span> }
    </div>
  );
}

PlayerImage.propTypes = {
  responseType: PropTypes.object.isRequired,
  answer: PropTypes.object,
}

export default PlayerImage;
